import { REPUB_CONFIG } from '@cx-web/repub-config';

import { type Repub } from '@cx-modules/types';

// Theme colours are inlined (formerly var(--ogm-*)) so the error page does not
// depend on the external repub theme stylesheets.
const TIMBERWOLVES = '#022e4a';
const SEAHAWKS = '#00e889';
const BUCKS = '#167c3f';
const WHITE = '#fff';

const styles = (backgroundColor: string) => `
            body,
            input {
                font-family: "Public Sans", sans-serif;
                background-color: ${backgroundColor};
                display: flex;
                max-width: 1250px;
                justify-content: center;
                align-items: center;
                min-width: 100%;
                height: 100vh;
            }

            p {
                display: block;
                margin-block-start: 1em;
                margin-block-end: 1em;
                margin-inline-start: 0px;
                margin-inline-end: 0px;
                font-family: "Public Sans", sans-serif;
            }

            code,
            kbd,
            pre {
                font-family: "Public Sans", sans-serif;
            }

            .mobileImage {
                display: none;
            }

            .desktopImage {
                margin-right: 20px;
            }

            .textSection {
                padding: 20px;
            }

            .homepage {
                background-color: ${SEAHAWKS};
                color: ${TIMBERWOLVES};
                border: none;
            }

            .homepage:hover {
                color: ${WHITE};
                background-color: ${BUCKS};
            }

            a {
                display: inline-block;
                border: 1px solid white;
                border-radius: 4px;
                background-color: ${TIMBERWOLVES};
                color: ${WHITE};
                padding: 10px;
                margin-bottom: 10px;
                margin-right: 8px;
                font-family: "Public Sans", sans-serif;
                font-weight: 700;
                text-decoration: none;
            }

            a:hover {
                background-color: ${WHITE};
                color: ${TIMBERWOLVES};
            }

            .buttonSection {
                padding-top: 10px;
            }

            .text {
                font-size: 18px;
                color: ${WHITE};
            }

            .oops {
                padding-top: 32px;
                font-family: "futura-pt-condensed", sans-serif;
                color: ${SEAHAWKS};
                font-size: 72px;
            }

            @media only screen and (max-width: 1024px) {
                body {
                    text-align: center;
                    margin: 0px;
                    padding: 0px;
                }

                .textSection {
                    height: 100%;
                    width: 100%;
                    padding: 12px;
                }

                .text {
                    font-size: 18px;
                }

                .desktopImage {
                    display: none;
                }

                .mobileImage {
                    display: flex;
                    height: 350px;
                    width: 350px;
                    margin: 20px auto;
                }

                .logo {
                    height: 30px;
                }
            }

            @media only screen and (max-width: 600px) {
                .oops {
                    font-size: 48px;
                }

                .text {
                    font-size: 16px;
                }

                .logo {
                    height: 20px;
                }

                .mobileImage {
                    height: 200px;
                    width: 200px;
                }
            }
        `;

export function ErrorPageStyles({ repub }: { repub: Repub }) {
  const backgroundColor = REPUB_CONFIG[repub]?.plus?.errorPage?.backgroundColor ?? TIMBERWOLVES;
  return <style dangerouslySetInnerHTML={{ __html: styles(backgroundColor) }} />;
}
